import React from "react";
import { Typography, Box } from "@mui/material";
import { formatJpDate } from "../../../utils/dateUtils";

/**
 * カード下部に表示する「掲載期限」
 */
const IndexCardFooter = ({ publishEndDate }) => {
  if (!publishEndDate) return null;

  return (
    <Box
      sx={{
        mt: 1.5,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", fontSize: { xs: "0.6rem", sm: "0.7rem" } }}
      >
        掲載期限 {formatJpDate(publishEndDate)} まで
      </Typography>

      {/* 詳細を見る */}
      <Typography
        variant="caption"
        sx={{
          fontSize: { xs: "0.6rem", sm: "0.7rem" },
          color: "text.secondary",
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        詳細を見る →
      </Typography>
    </Box>
  );
};

export default IndexCardFooter;
